/* Trust row swiper dots (handbook §5.6): Impulse "Text columns with icons" on the home page and product
   pages. Under 760px tl-trust.css makes the blocks a scroll-snap row; these dots follow the centred card and
   scroll to their card when tapped. The row is position:relative, so offsetLeft is relative to it. */
(() => {
  const still = matchMedia('(prefers-reduced-motion: reduce)');
  // Index of the child whose centre is nearest the scroller's centre.
  const near = (s, items) => {
    let c = s.scrollLeft + s.clientWidth / 2, best = 0, d = 1e9;
    items.forEach((el, i) => {
      const x = Math.abs(el.offsetLeft + el.offsetWidth / 2 - c);
      if (x < d) d = x, best = i;
    });
    return best;
  };
  const center = (s, el) => s.scrollTo({
    left: el.offsetLeft - (s.clientWidth - el.offsetWidth) / 2,
    behavior: still.matches ? 'auto' : 'smooth'
  });

  const init = root => root.querySelectorAll('.text-with-icons__blocks').forEach(s => {
    const items = [...s.children];
    if (s.dataset.tlOn || items.length < 2) return;
    s.dataset.tlOn = 1;
    const nav = document.createElement('div');
    nav.className = 'tl-trust-dots';
    const dots = items.map(it => {
      const b = nav.appendChild(document.createElement('button'));
      b.type = 'button';
      b.setAttribute('aria-label', (it.querySelector('h3') || it).textContent.trim());
      b.onclick = () => center(s, it);
      return b;
    });
    s.after(nav);
    const sync = () => {
      const i = near(s, items);
      dots.forEach((b, j) => {
        b.classList.toggle('is-on', i == j);
        b.setAttribute('aria-current', i == j);
      });
    };
    let q;
    s.addEventListener('scroll', () => { q = q || requestAnimationFrame(() => { q = 0; sync(); }); }, { passive: true });
    // Crossing 760px (rotation, window resize) swaps grid <-> swiper without a scroll event.
    addEventListener('resize', sync);
    sync();
  });

  document.readyState == 'loading' ? document.addEventListener('DOMContentLoaded', () => init(document)) : init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
